import { render } from "./WiseCountrySelector.vue?vue&type=template&id=fde8d1ba&scoped=true"
import script from "./WiseCountrySelector.vue?vue&type=script&lang=js"
export * from "./WiseCountrySelector.vue?vue&type=script&lang=js"

import "./WiseCountrySelector.vue?vue&type=style&index=0&id=fde8d1ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fde8d1ba"]])

export default __exports__